export default "__VITE_ASSET__BvIgtBqn__"